import React from 'react'
import {ColorPickerContainer} from './ColorPickerContainer'
import {Colors} from './Colors'

const ColorPicker = ({targetEl, value, onChange = (e, v) => {}, onClose = e => {}}) => {
  const handleChange = (e, v) => {
    onChange(e, v)
    onClose()
  }

  return (
    <ColorPickerContainer
      show={!!targetEl}
      targetEl={targetEl}
      onClose={onClose}
      style={{width: 'auto', maxHeight: 'none', padding: '15px 15px 15px 15px'}}
      offset={{x: 0, y: 8}}
    >
      <div style={{display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', width: 'auto'}}>
        {Colors.map(c => (
          <button
            className="ds-circ-btn ds-circ-btn--fill"
            style={{'--ds-bg': c, width: 40, height: 40}}
            onClick={e => handleChange(e, c)}
          >
            {value.toUpperCase() === c && <i class="ds-icon-check ds-tg000"></i>}
          </button>
        ))}
      </div>
    </ColorPickerContainer>
  )
}

export default ColorPicker
